import { Injectable } from '@angular/core';
import {
  GeolocationInput,
  MapProvider,
} from '@fullyops/shared/services/geolocation/providers/map-provider';
import { GoogleMapsProvider } from '@fullyops/shared/services/geolocation/providers/google-maps-provider';
import { AppleMapsProvider } from '@fullyops/shared/services/geolocation/providers/apple-maps-provider';
import { WazeProvider } from '@fullyops/shared/services/geolocation/providers/waze-provider';

@Injectable({
  providedIn: 'root',
})
export class GeolocationService {
  private mapProviders: Map<string, MapProvider> = new Map();

  constructor() {
    this.registerProvider(new GoogleMapsProvider());
    this.registerProvider(new AppleMapsProvider());
    this.registerProvider(new WazeProvider());
  }

  registerProvider(provider: MapProvider): void {
    this.mapProviders.set(provider.name, provider);
  }

  generateAllUrls(
    destination: GeolocationInput,
  ): { providerName: string; url: string }[] {
    return Array.from(this.mapProviders, ([providerName, provider]) => {
      return {
        providerName,
        url: provider.generateUrl(destination),
      };
    });
  }
}
